(function ($) {
 
  // Mobile Menu
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 100) {
      $('.site-header__wrapper').addClass('scrolled');
      $('nav div').addClass('visible-title');
    } else {
      $('.site-header__wrapper').removeClass('scrolled');
    }
  });

  // Stop scroll when menu open
  $('.menu-toggle').click(function () {
    $('html').toggleClass('active');  
  });  
  

  // Load More Button - Posts from the Category Page 
  $(".load-more--category-posts").on("click", function(e){
    e.preventDefault();
    $(".category-items__item:hidden").slice(0, 4).slideDown();
    if($(".category-items__item:hidden").length == 0) {
      $(".load-more--category-posts").text("End of content").addClass("no-content");
    }
  });

  // Load More Button - Posts from the Post Feed Block
  $(".load-more--posts").on("click", function(e){
    e.preventDefault();
    $(".load-items__item:hidden").slice(0, 3).slideDown();
    if($(".load-items__item:hidden").length == 0) {
      $(".load-more--posts").text("End of content").addClass("no-content");
    }
  });


  function isScrolledIntoView($elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return (
      elemBottom >= docViewTop &&
      elemTop <= docViewBottom
    );
  }


  // Title Line Animation
 $(window).scroll(function(){
  $('.title-line').each(function(){
    if(isScrolledIntoView($(this))){
      $(this).addClass('show');
    }
    else{
       $(this).removeClass('show');
    }
  });
});


// Carousel Block
  $('.carousel-block__images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    cssEase: 'linear',
    pauseOnHover: true,
    pauseOnFocus: true,
  });


// Featured Block
$('.featured-block__items').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: false,
  cssEase: 'linear',
  pauseOnHover: true,
  pauseOnFocus: true,
  centerMode: false,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


  // FAQ Accordion
$(function(){
  $('.faq-block__item').click(function(){
    if($(this).hasClass('active')) {         
      $('.faq-block__answer').slideUp();
      $('.faq-block__item').removeClass('active');
    }
    else
    {      
      $('.faq-block__item').removeClass('active');   
      $(this).addClass('active');
      $('.faq-block__answer').slideUp();
      $(this).find('.faq-block__answer').slideDown();
    }
  });
});


})(jQuery);


// Load Google Maps API
(function() {
  var script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBJjLdM2BGzorjmodPPoXpfGtC5eVAzbzQ';
  script.async = true;
  script.defer = true;

  script.onload = function() {
    initMap();
    initHospitalMap();
  };

  document.head.appendChild(script);
})();



document.addEventListener('pointerup', function(e) {
  var parentItem = e.target.closest('.main-navigation .menu-item-has-children');

  if (!parentItem) return;
  if (e.target.closest('.sub-menu')) return;

  var link = parentItem.querySelector('a');

  if (!link) return;

  var href = link.getAttribute('href');

  if (href && href !== '#') {
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(href);
  }
}, true);